import React, { useEffect, useMemo, useState } from "react";

const LoadingComponent = () => {
  const messages = useMemo(
    () => [
      "Preparation de l'experience...",
      "Chargement des projets recents...",
      "Assemblage du portfolio...",
      "Verification des derniers details...",
      "Presque pret.",
    ],
    []
  );
  const [currentMessage, setCurrentMessage] = useState(messages[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      const newMessage = messages[Math.floor(Math.random() * messages.length)];
      setCurrentMessage(newMessage);
    }, 2200);

    return () => clearInterval(interval);
  }, [messages]);

  useEffect(() => {
    const contentDiv = document.getElementById("container");
    if (!contentDiv) return undefined;

    const handleContent = () => {
      contentDiv.classList.add("charger");
      setTimeout(() => {
        contentDiv.style.display = "none";
      }, 1100);
    };

    if (document.readyState === "complete") {
      handleContent();
    } else {
      window.addEventListener("load", handleContent);
    }

    return () => window.removeEventListener("load", handleContent);
  }, []);

  return (
    <div id="container">
      <div id="loader"></div>
      <p id="text">{currentMessage}</p>
    </div>
  );
};

export default LoadingComponent;
